/**
 * Asynchronously loads the component for ReleasePage
 */

import { lazyLoad } from 'utils/loadable';

export const TestLab = lazyLoad(
  () => import('./index'),
  module => {
    return module.TestLab;
  },
);
